import Header from "./components/Header";
import TVPlayer from "./pages/TVPlayer";

function App() {
    return (
        <div>
            <Header></Header>
            <TVPlayer></TVPlayer>
        </div>
    );
}

export default App;
